import React from 'react';
import BottomSheet from '../Shared/BottomSheet';
import { Button } from '../ui/atoms/Button/Button';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onGoToList: () => void;
  onCreateNew: () => void;
  info: {
    createdAt: string;
    totalItems: number;
    checkedCount: number;
  };
};

const ProgressConflictModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onGoToList,
  onCreateNew,
  info,
}) => {
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <div className="space-y-4 pb-5">
        <h2 className="text-lg font-semibold">You already have a shopping list</h2>
        <p className="text-sm text-gray-600">
          You created it on{' '}
          <strong>{new Date(info.createdAt).toLocaleString()}</strong>. 
        <p>It has{' '}
          <strong>{info.totalItems}</strong> items,{' '}
          <strong>{info.checkedCount}</strong> checked off.
        </p>
        </p>
        <div className="space-y-2">
          <Button
            onClick={onGoToList}
            variant="outline"
            className="w-full bg-primary text-white py-2 hover:bg-blue-700"
          >
            Go to the existing Shopping List
          </Button>
          <Button
            onClick={onCreateNew}
            variant="outline"
            className="w-full bg-gray-100 border border-gray-300 text-gray-800 py-2"
          >
            Replace it with a New Shopping List
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};

export default ProgressConflictModal;
